module.exports = __webpack_public_path__ + "assets/images/dcea39ad03938a4bf1f804706b4280df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/foursquare.svg
// module id = 725
// module chunks = 0